import { render, staticRenderFns } from "./VideoWithPoster.vue?vue&type=template&id=d3f7e4a8&scoped=true"
import script from "./VideoWithPoster.vue?vue&type=script&lang=js"
export * from "./VideoWithPoster.vue?vue&type=script&lang=js"
import style0 from "./VideoWithPoster.vue?vue&type=style&index=0&id=d3f7e4a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f7e4a8",
  null
  
)

export default component.exports